// extracted by mini-css-extract-plugin
export default {"CompanyManagement":"styles_CompanyManagement__sGofg","container":"styles_container__iNHAp"};